module.exports = __webpack_public_path__ + "static/flags/KM-2f0b04e337439b2e547f927f0c3134b2.gif";